import { action } from 'mobx';

import { request } from 'utils/api';
import BaseStore from 'common/stores/BaseStore';

export default class FreedomPayStore extends BaseStore {
  @action
  initCard({ amount, orderId }) {
    return request({
      method: 'POST',
      path: `/1/freedompay/init/card`,
      body: {
        amount,
        orderId,
      },
    });
  }

  @action
  initGoogle({ amount, orderId }) {
    return request({
      method: 'POST',
      path: `/1/freedompay/init/google`,
      body: {
        amount,
        orderId,
      },
    });
  }

  @action
  initApple({ amount, orderId }) {
    return request({
      method: 'POST',
      path: `/1/freedompay/init/apple`,
      body: {
        amount,
        orderId,
      },
    });
  }
}
